import { selectors as authSelectors } from '@hixme/auth-ui'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getRequestByName } from 'modules/redux-gateway'
import convert from 'htmr'
// import html from 'modules/notes/rules/htmlRules'

import { selectors as tagSelectors, actions as tagActions } from '../../tags'

import { NoteCard } from '../components/'
import { actions, constants, selectors } from '../'

const mapStateToProps = (state, { note }) => {
  const credentials = authSelectors.getCredentials(state)
  const noteReq = getRequestByName(state, constants.NOTE_ALL_GET)
  const noteLoading = selectors.noteLoading(state) === note.Id
  const isExpanded = selectors.isNoteExpanded(state, note.Id) || false
  const { isChanged, isLoaded, isEditing, isUpdating } =
    tagSelectors.getTag(state, note.Id) || []

  const value = (note.Body && convert(note.Body)) || ''

  return {
    credentials,
    isAdmin: credentials.userRole.indexOf('Admin') !== -1,
    isExpanded,
    noteLoading,
    noteReq,
    value,
    isChanged,
    isLoaded,
    isEditing,
    isUpdating,
  }
}

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(actions, dispatch),
  ...bindActionCreators(tagActions, dispatch),
})

const mergeProps = (stateProps, dispatchProps, props) => ({
  ...stateProps,
  ...dispatchProps,
  ...props,
  closeEditTags: () => {
    dispatchProps.updateTags(props.note.Id)
  },
  toggleEditTags: () => {
    dispatchProps.clearPostNote(constants.EMPTY_STATE)
    dispatchProps.editTags(props.note.Id)
  },
  expandNote: (note, id) => () => {
    dispatchProps.setExpandNote(note, id)
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(NoteCard)
